module.exports = __webpack_public_path__ + "media/images/pc/articles/recommend_temp_01-8ea3776ec3963dead1383b9e1d9ccca9.webp";